import SubSection from './SubSection.gql';

export default SubSection;
